import FinalConsumerContainer from './FinalConsumer'
export default FinalConsumerContainer
